import { PreviouslyBoughtList } from '../../components/PreviouslyBoughtTable/PreviouslyBoughtList';
import { useTranslation } from '../../i18n/i18n';
import { Res, useApi } from '../../state/api';
import { ContentCard } from '../ContentCard/ContentCard';
import { ErrorPage } from './ErrorPage';
import { Main } from '../Main/Main';
import { Routing } from '../Routes';
import './PreviouslyBoughtPage.css';
import { Loader } from '../Loader/Loader';
import { AccountPageNavigation } from '../AccountPageNavigation/AccountPageNavigation';

export const PreviouslyBoughtPage = (): JSX.Element => {
	const { data: products, error, isLoading } = useApi(Res.previouslyBought, {});
	const t = useTranslation().previouslyBoughtPage;

	if (error) return <ErrorPage />;
	if (!products || isLoading) {
		return (
			<Main>
				<AccountPageNavigation />
				<div id="previously-bought-page">
					<h1 className="private-page-heading">{t.purchasedItems}</h1>
					<p className="heading-text">{t.belowYouFindProducts}</p>
					<ContentCard>
						<Loader />
					</ContentCard>
				</div>
			</Main>
		);
	}
	if (products.boughtProducts.length === 0) {
		return (
			<Main>
				<AccountPageNavigation />
				<div id="previously-bought-page">
					<h1>{t.purchasedItems}</h1>
					<p className="heading-text">{t.noProductsBought}</p>
				</div>
			</Main>
		);
	}

	return (
		<Main>
			<AccountPageNavigation />
			<div id="previously-bought-page">
				<h1 className="private-page-heading">{t.purchasedItems}</h1>
				<p className="heading-text">{t.belowYouFindProducts}</p>
				<PreviouslyBoughtList products={products.boughtProducts} />
			</div>
		</Main>
	);
};

export const previouslyBoughtRouting: Routing = {
	path(urls) {
		return urls.previouslyBought;
	},
	component: PreviouslyBoughtPage,
	requiresAuth: true,
};
